
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M28.163 17.33a1 1 0 00-1.264-.184c-2.17 1.325-3.035 2.973-3.074 4.667-.036 1.586.663 3.038 1.184 4.01.209.39.248.62.25.73.002.087-.018.113-.03.13a.647.647 0 01-.21.156c-.112.06-.223.103-.362.156l-.057.022c-.108.042-.376.14-.751.278-.64.235-1.59.584-2.596.963-.783.296-1.586.604-2.258.876-.647.261-1.241.515-1.56.697-.051.03-.112.062-.181.099-.455.244-1.257.676-1.795 1.439-.513.727-.745 1.652-.611 2.831H9a1 1 0 00-.542 1.84l12.05 7.78a1 1 0 00.542.16H39.2a1 1 0 00.542-.16l12.05-7.78a1 1 0 00-.542-1.84h-3.739c.108-.504.17-1.068.142-1.681-.059-1.267-.498-2.677-1.587-4.16-.603-.823-1.576-1.574-2.628-2.239-1.072-.677-2.315-1.32-3.542-1.9a89.8 89.8 0 00-3.514-1.55l-.584-.245c-.795-.333-1.431-.6-1.85-.798l-.132-.063c-1.033-.49-1.79-.85-2.602-1.41-.839-.578-1.763-1.394-3.051-2.823zM16.053 36.2h31.805l-8.953 5.78H21.345l-8.952-5.78h3.66zm29.397-2.01H16.864c-.152-.935.045-1.407.23-1.669.245-.349.583-.536 1.047-.793.09-.05.185-.102.284-.16.181-.102.644-.307 1.32-.58.65-.263 1.436-.565 2.214-.859.957-.36 1.925-.716 2.583-.958a81.464 81.464 0 00.835-.31c.27-.1.987-.365 1.445-.97a2.17 2.17 0 00.437-1.373c-.01-.524-.182-1.07-.488-1.64-.509-.95-.97-1.997-.946-3.019.018-.777.32-1.665 1.446-2.545 1.073 1.134 1.952 1.896 2.807 2.486.948.654 1.84 1.078 2.839 1.55l.174.083c.464.22 1.158.512 1.956.846l.56.235c1.046.44 2.245.954 3.435 1.515 1.191.563 2.353 1.166 3.328 1.782.993.628 1.707 1.218 2.084 1.73.87 1.187 1.162 2.222 1.2 3.07a4.693 4.693 0 01-.204 1.579z"}})])
          )
        }
      }
    